import React from 'react';
import { motion } from 'framer-motion';
interface PullQuoteProps {
  quote: string;
  attribution?: string;
}
export function PullQuote({
  quote,
  attribution
}: PullQuoteProps) {
  return <motion.figure initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5
  }} className="my-12 border-l-2 border-trust-500 pl-6 md:pl-8" data-id="element-90">
      <blockquote className="font-serif text-ink text-2xl md:text-3xl leading-snug tracking-tightest" style={{
      fontWeight: 400
    }} data-id="element-91">
        “{quote}”
      </blockquote>
      {attribution && <figcaption className="mt-4 eyebrow text-stone-500" data-id="element-92">
          {attribution}
        </figcaption>}
    </motion.figure>;
}